/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateResourceObjectMonetaryValueRequest,
  GetResourceObjectMonetaryValuesParams,
  ResourceObjectMonetaryValueDto,
  UpdateResourceObjectMonetaryValueRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetResourceObjectMonetaryValuesUrl = (params?: GetResourceObjectMonetaryValuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObjectMonetaryValue/GetResourceObjectMonetaryValues?${stringifiedParams}` : `/api/ResourceObjectMonetaryValue/GetResourceObjectMonetaryValues`
}

export const getResourceObjectMonetaryValues = async (params?: GetResourceObjectMonetaryValuesParams, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectMonetaryValueDto[]> => {

  return customInstance<ResourceObjectMonetaryValueDto[]>(getGetResourceObjectMonetaryValuesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetResourceObjectMonetaryValuesQueryKey = (params?: GetResourceObjectMonetaryValuesParams,) => {
    return [
    `/api/ResourceObjectMonetaryValue/GetResourceObjectMonetaryValues`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResourceObjectMonetaryValuesQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectMonetaryValuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>> = ({ signal }) => getResourceObjectMonetaryValues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceObjectMonetaryValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>>
export type GetResourceObjectMonetaryValuesQueryError = ErrorType<unknown>


export function useGetResourceObjectMonetaryValues<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectMonetaryValuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectMonetaryValues<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>,
          TError,
          Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectMonetaryValues<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectMonetaryValues<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectMonetaryValuesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetResourceObjectMonetaryValuesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceObjectMonetaryValuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>> = ({ signal }) => getResourceObjectMonetaryValues(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetResourceObjectMonetaryValuesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>>
export type GetResourceObjectMonetaryValuesSuspenseQueryError = ErrorType<unknown>


export function useGetResourceObjectMonetaryValuesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceObjectMonetaryValuesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectMonetaryValuesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceObjectMonetaryValuesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetResourceObjectMonetaryValuesSuspense<TData = Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError = ErrorType<unknown>>(
 params?: GetResourceObjectMonetaryValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceObjectMonetaryValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceObjectMonetaryValuesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateResourceObjectMonetaryValueUrl = () => {




  return `/api/ResourceObjectMonetaryValue/CreateResourceObjectMonetaryValue`
}

export const createResourceObjectMonetaryValue = async (createResourceObjectMonetaryValueRequest: CreateResourceObjectMonetaryValueRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectMonetaryValueDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectMonetaryValueDto>(getCreateResourceObjectMonetaryValueUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createResourceObjectMonetaryValueRequest)
  }
);}





export const getCreateResourceObjectMonetaryValueMutationKey = () => ['createResourceObjectMonetaryValue'] as const;

export const getCreateResourceObjectMonetaryValueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectMonetaryValue>>, TError,CreateResourceObjectMonetaryValueMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectMonetaryValue>>, TError,CreateResourceObjectMonetaryValueMutationVariables, TContext> => {

const mutationKey = getCreateResourceObjectMonetaryValueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createResourceObjectMonetaryValue>>, CreateResourceObjectMonetaryValueMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createResourceObjectMonetaryValue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateResourceObjectMonetaryValueMutationResult = NonNullable<Awaited<ReturnType<typeof createResourceObjectMonetaryValue>>>
    export type CreateResourceObjectMonetaryValueMutationBody = BodyType<CreateResourceObjectMonetaryValueRequest>
    export type CreateResourceObjectMonetaryValueMutationError = ErrorType<unknown>
    export type CreateResourceObjectMonetaryValueMutationVariables = {data: BodyType<CreateResourceObjectMonetaryValueRequest>}

    export const useCreateResourceObjectMonetaryValue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createResourceObjectMonetaryValue>>, TError,CreateResourceObjectMonetaryValueMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createResourceObjectMonetaryValue>>,
        TError,
        CreateResourceObjectMonetaryValueMutationVariables,
        TContext
      > => {
      return useMutation(getCreateResourceObjectMonetaryValueMutationOptions(options), queryClient);
    }
    export const getUpdateResourceObjectMonetaryValueUrl = () => {




  return `/api/ResourceObjectMonetaryValue/UpdateResourceObjectMonetaryValue`
}

export const updateResourceObjectMonetaryValue = async (updateResourceObjectMonetaryValueRequest: UpdateResourceObjectMonetaryValueRequest, options?: Parameters<typeof customInstance>[1]): Promise<ResourceObjectMonetaryValueDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ResourceObjectMonetaryValueDto>(getUpdateResourceObjectMonetaryValueUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateResourceObjectMonetaryValueRequest)
  }
);}





export const getUpdateResourceObjectMonetaryValueMutationKey = () => ['updateResourceObjectMonetaryValue'] as const;

export const getUpdateResourceObjectMonetaryValueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectMonetaryValue>>, TError,UpdateResourceObjectMonetaryValueMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectMonetaryValue>>, TError,UpdateResourceObjectMonetaryValueMutationVariables, TContext> => {

const mutationKey = getUpdateResourceObjectMonetaryValueMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateResourceObjectMonetaryValue>>, UpdateResourceObjectMonetaryValueMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateResourceObjectMonetaryValue(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateResourceObjectMonetaryValueMutationResult = NonNullable<Awaited<ReturnType<typeof updateResourceObjectMonetaryValue>>>
    export type UpdateResourceObjectMonetaryValueMutationBody = BodyType<UpdateResourceObjectMonetaryValueRequest>
    export type UpdateResourceObjectMonetaryValueMutationError = ErrorType<unknown>
    export type UpdateResourceObjectMonetaryValueMutationVariables = {data: BodyType<UpdateResourceObjectMonetaryValueRequest>}

    export const useUpdateResourceObjectMonetaryValue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateResourceObjectMonetaryValue>>, TError,UpdateResourceObjectMonetaryValueMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateResourceObjectMonetaryValue>>,
        TError,
        UpdateResourceObjectMonetaryValueMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateResourceObjectMonetaryValueMutationOptions(options), queryClient);
    }
